import {useLanguage} from "../../../LanguageContext";
import {Box, Typography} from "@mui/material";
import React, {useEffect, useRef, useState} from "react";
import {
    circleStyle,
    containerStyle,
    dayActivitiesLiStyle,
    dayActivitiesTextStyle,
    dayActivitiesUlStyle,
    dayContainerStyle,
    dayItemStyle,
    dayTittleTextStyle,
    lineStyle
} from "../../styles/TripTabStyles";
import {useLocation} from "react-router-dom";
import {AdventureTextComponent} from "./AdventureTextComponent";


const TripTab = ({days}) => {
    const {t} = useLanguage();

    const containerRef = useRef(null);
    const lastCircleRef = useRef(null);
    const [lineHeight, setLineHeight] = useState(0);

    const {pathname} = useLocation();

    useEffect(() => {
        const updateLineHeight = () => {
            if (containerRef.current && lastCircleRef.current) {

                const containerTop = containerRef.current.getBoundingClientRect().top;
                const lastCircleTop = lastCircleRef.current.getBoundingClientRect().top;
                setLineHeight(lastCircleTop - containerTop - 60); // Adjust based on circle size (16px is an example offset)
            }
        };

        updateLineHeight();
        window.addEventListener("resize", updateLineHeight);

        return () => {
            window.removeEventListener("resize", updateLineHeight);
        };
    }, [pathname, t]);


    return (
        <Box>
            <Box ref={containerRef}
                 sx={{
                     backgroundColor: '#FFFFFF',
                     pb: '24px',
                     position: 'relative',
                 }}>
                <Box sx={containerStyle(lineHeight)}>
                    {days.map((item, index) => {
                        return (
                            <Box
                                key={index}
                                sx={dayItemStyle(index)}
                            >
                                {/*circle*/}
                                <Box
                                    sx={circleStyle(index)}
                                    ref={index === days.length - 1 ? lastCircleRef : null}
                                />
                                <Box
                                    sx={dayContainerStyle}
                                >
                                    <Typography style={dayTittleTextStyle}>
                                        {t(item.day).toUpperCase()}
                                    </Typography>
                                    <ul style={dayActivitiesUlStyle}>
                                        {t(item.activities).map((activity, index) => (
                                            <Box
                                                key={index}
                                                sx={{
                                                    // pl:'20px',
                                                }}
                                            >
                                                <li
                                                    style={dayActivitiesLiStyle}>
                                                    <Typography
                                                        style={dayActivitiesTextStyle}>
                                                        {activity}
                                                    </Typography></li>
                                            </Box>

                                        ))}
                                    </ul>
                                </Box>
                            </Box>
                        );
                    })}
                </Box>
                <AdventureTextComponent/>
                <Box sx={lineStyle(lineHeight)}/>
            </Box>

        </Box>

    );
}


export default TripTab;
